/** @file drawable.remove: removes a drawable from the puppet. */
import type { CommandDef } from '../apply/commandDef';
import { puppetInverse } from '../apply/puppetInverse';
import { readInput } from '../validate/readInput';
import { findDrawable } from './findDrawable';

/** `drawable.remove { drawable }` → `{}`; inverse: `drawable.add` when it was the last drawable, else P. */
export const drawableRemoveCommand: CommandDef<'drawable.remove'> = {
  name: 'drawable.remove',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => ({ drawable: readInput(input, path, ['drawable']).str('drawable') }),
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const p = draft.puppet;
    const { index, drawable } = findDrawable(p, input.drawable);
    const inverse = index === p.drawables.length - 1
      ? [{ name: 'drawable.add' as const, input: { drawable: structuredClone(drawable) } }]
      : puppetInverse(draft);
    p.drawables.splice(index, 1);
    return { result: {}, warnings: [], inverse };
  },
};
